<template>
  <div class="order-quantity">
    <div class="qty-select">
      <select class="form-control qty-dropdown" v-model="selectedOption" @change="onSelectChange">
        <option v-for="opt in options" :key="opt.value" :value="opt.value">
          {{opt.label}}
        </option>
        <option value="custom">{{$t('checkout.quantityCustom')}}</option>
      </select>
    </div>
    <div class="qty-custom" v-if="isCustom">
      <input type="number" class="form-control" v-model.number="customNum" min="1" max="100"
             :placeholder="$t('checkout.quantityInputPlaceholder')"
             @change="onCustomChange">
    </div>
  </div>
</template>

<script>
export default {
  name: 'order-quantity',
  props: {
    number: { type: Number, default: 1 },
    perCost: { type: Number, default: 0 },
    symbol: { type: String, default: '$' }
  },
  data () {
    const isPreset = [1, 2, 3, 5].includes(this.number)
    return {
      selectedOption: isPreset ? this.number : 'custom',
      customNum: isPreset ? '' : this.number,
      isCustom: !isPreset
    }
  },
  computed: {
    options () {
      // 多本不打折 —— n本 = perCost × n
      const unit = this.$t('checkout.quantityUnit')
      const single = this.$t('checkout.quantityUnitSingular') || unit
      const fmt = (n) => this.perCost ? ` - ${this.symbol}${(this.perCost * n).toFixed(2)}` : ''
      return [
        { value: 1, label: `1${single}${fmt(1)}` },
        { value: 2, label: `2${unit}${fmt(2)}` },
        { value: 3, label: `3${unit}${fmt(3)}` },
        { value: 5, label: `5${unit}${fmt(5)}` }
      ]
    }
  },
  methods: {
    onSelectChange () {
      if (this.selectedOption === 'custom') {
        this.isCustom = true
        this.customNum = this.number
        return
      }
      this.isCustom = false
      this.$emit('change', Number(this.selectedOption))
    },
    onCustomChange () {
      const num = Math.max(1, Math.min(100, this.customNum || 1))
      this.customNum = num
      this.$emit('change', num)
    }
  }
}
</script>

<style lang="scss" scoped>
.order-quantity {
  .qty-select {
    .qty-dropdown {
      width: 60%;
      padding: 10px 12px;
      font-size: 14px;
      line-height: 1.5;
      height: auto;
      border-radius: 8px;
      border: 1px solid #e0e0e0;
      background: #fafafa;
      cursor: pointer;
      -webkit-appearance: none;
      appearance: none;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: right 12px center;
      padding-right: 32px;
      &:focus { border-color: $el-color-primary; outline: none; }
    }
  }
  .qty-custom {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 10px;
    .form-control {
      max-width: 120px;
      border-radius: 8px;
    }
  }
}
</style>
